<template>
  <b-modal ref="modalInfo" :hideFooter="true" size="lg" title="Project finances" @hidden="onHide">
    <div class="row" v-if="report">
      <div class="col-12 m-form m-form--state">
        <div class="row mb-4">
          <div class="col-4">
            <span class="right-border"><i class="far fa-user icon"></i> {{ client.name }}</span>
          </div>
          <div class="col">
            <span class="right-border"><i class="fas fa-suitcase icon"></i> {{ project.name }}</span>
          </div>
        </div>

        <div v-if="fixedPrice > 0">
          <b>Fixed:</b> € {{ fixedPrice.toFixed(2) }}
        </div>
        <div v-else>
          <b>Paid hours:</b> {{ paidHours.toFixed(2) }} h X {{ client.price_per_hour }} €/h = € {{ paidHoursTimesRate }}
        </div>

        <div v-if="project.pvsyst_2d">
          <b>2D Pvsyst projects:</b> {{ project.pvsyst_2d }}
        </div>
        <div v-if="project.pvsyst_3d">
          <b>3D Pvsyst projects:</b> {{ project.pvsyst_3d }}
        </div>

        <div class="mt-4">
          <b>Total: € {{ total.toFixed(2) }}</b>
        </div>

        <div class="mt-4">Last billed: {{ lastBilledAt ? lastBilledAt : '-' }}</div>

        <div class="text-center mt-3">
          <div class="btn btn-metal" @click="hide()">Close</div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
  import bModal from 'bootstrap-vue/src/components/modal/modal'
  import moment from 'moment'

  export default {
    components: {
      'b-modal': bModal
    },

    data() {
      return {
        project: null,
        report: null,
        client: null,
        lastBilledAt: null,
      }
    },
    methods: {
      open(client, project) {
        this.client = client
        this.project = project
        this.axios.get('/projects/' + project.id)
          .then(res => {
            this.report = res.data
          })
          .catch(err => console.log(err))

        this.axios.get('projects/lastBilledAt/' + project.id).then(response => {
          this.lastBilledAt = moment(response.data).format('Y-MM-DD')
        })

        this.$refs.modalInfo.show()
      },

      hide() {
        this.$refs.modalInfo.hide()
        this.onHide()
      },

      onHide() {
        this.project = null
        this.client = null
        this.report = null
      }
    },

    computed: {
      fixedPrice: function () {
        if (this.project.fixed_price)
          return this.project.fixed_price
        else
          return 0
      },
      paidHours: function () {
        return this.report.income_types.hourly_total
      },
      paidHoursTimesRate: function () {
        return this.paidHours * this.client.price_per_hour
      },
      additionalServices: function () {
        return this.report.income_types.pvsyst_2d * constants.pvsyst_2d_price
          + this.report.income_types.pvsyst_3d * constants.pvsyst_3d_price
      },
      total: function () {
        return this.report.generated_money
      }
    }
  }
</script>

<style scoped>
  * {
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/clients/projects/ProjectInfo.vue